import adminCards from 'utils/adminCards.ts';

export function getWriteRoles(roles: string[]): string[] {
  return roles.filter((role: string) => role.endsWith(':write'));
}

export function getAdminRoles(roles: string[]): string[] {
  return roles.filter((role: string) => adminCards.some(({ requiredRole }) => role.endsWith(requiredRole)));
}

export function getTeamIdFromRole(role: string): string {
  const idx = role.lastIndexOf(':');
  return idx === -1 ? role : role.slice(0, idx);
}
